export default __webpack_public_path__ + "static/media/closeIcon.63300067.svg";